import { render, staticRenderFns } from "./banka.vue?vue&type=template&id=72677714&scoped=true&"
import script from "./banka.vue?vue&type=script&lang=js&"
export * from "./banka.vue?vue&type=script&lang=js&"
import style0 from "./banka.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./banka.vue?vue&type=style&index=1&id=72677714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72677714",
  null
  
)

export default component.exports